export type RewardPackage = {
  status?: string; package_mode?: string; creator_reward_per_review?: number;
  platform_options_enabled?: boolean; bonus_reward_share_percent?: number; reward_share_percent?: number;
  platform_options?: { platform: string; price_per_creator: number }[];
};
export function merchantRewardRange(items: RewardPackage[]): string | null {
  const ranges = items.filter(p => (!p.status || p.status === 'active') && Number(p.creator_reward_per_review) > 0).map(p => {
    const base = Number(p.creator_reward_per_review);
    const share = p.bonus_reward_share_percent ?? p.reward_share_percent ?? 70;
    const bonus = p.package_mode === 'media' && p.platform_options_enabled
      ? (p.platform_options || []).filter(o => o.platform !== 'beaw').reduce((sum, o) => sum + Math.max(0, Math.round(o.price_per_creator * share / 100)), 0) : 0;
    return [base, base + bonus];
  });
  if (!ranges.length) return null;
  const min = Math.min(...ranges.map(r => r[0])), max = Math.max(...ranges.map(r => r[1]));
  return min === max ? `฿${min.toLocaleString('th-TH')}` : `฿${min.toLocaleString('th-TH')}–${max.toLocaleString('th-TH')}`;
}
